export default [

    {
        path: '/tributacion/migrar-Excel',
        name: 'tributacion-migrar-excel',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/RDEP_MigrarExcel.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-migrar-excel',
            pageTitle: 'Migrar desde Excel RDEP',
            breadcrumb: [{
                text: 'Migrar desde Excel RDEP',
                active: true,
            }, ],
        },
    },

    {
        path: '/tributacion/reporte-Form103',
        name: 'tributacion-reporte-Form103',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/ReporteForm103.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-reporte-103',
            pageTitle: 'Reporte Formulario 103',
            breadcrumb: [{
                text: 'Reporte Formulario 103',
                active: true,
            }, ],
        },
    },
    {
        path: '/tributacion/reporte-Form107',
        name: 'tributacion-reporte-Form107',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/ReporteForm107.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-reporte-107',
            pageTitle: 'Reporte Formulario 107',
            breadcrumb: [{
                text: 'Reporte Formulario 107',
                active: true,
            }, ],
        },
    },
    {
        path: '/tributacion/reporte-ComprasServicios',
        name: 'tributacion-reporte-ComprasServicios',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/ReporteComprasServicios.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-reporte-comprasServicios',
            pageTitle: 'Reporte Compras Servicios',
            breadcrumb: [{
                text: 'Reporte Compras Servicios',
                active: true,
            }, ],
        },
    },

    {
        path: '/tributacion/reportesRDEP-Tabulador',
        name: 'tributacion-reportesRDEP-tabulador',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/ReportesTabulados.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-reporte-tabulado-rdep',
            pageTitle: 'Reportes Tabulados RDEP',
            breadcrumb: [{
                text: 'Reportes Tabulados RDEP',
                active: true,
            }, ],
        },
    },

    {
        path: '/tributacion/procesosRDEP',
        name: 'tributacion-procesos-RDEP',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/RDEP_Procesos.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-generar-xml',
            pageTitle: 'Generar Archivo XML - RDEP',
            breadcrumb: [{
                text: 'Generar Archivo XML - RDEP',
                active: true,
            }, ],
        },
    },


    {
        path: '/tributacion/secuencial-documentos-emitidos',
        name: 'secuencial-documentos-emitidos',
        component: () =>
            import ('@/views/pages/tributacion/SRI/SecuencialDocumentos.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-secuencial',
            pageTitle: 'Secuencial Documentos emitidos',
            breadcrumb: [{
                text: 'Secuencial Documentos',
                active: true,
            }, ],
        },
    },

    {
        path: '/tributacion/permisos-ventanas-tributacion',
        name: 'tributacion-permisos-ventanas-tributacion',
        component: () =>
            import ('@/views/pages/tributacion/SRI/PermisosVentanasUsuarios.vue'),
        meta: {
            title: 'i18n:',
            // resource: 'Tributacion',
            // action: 'ver-tributacion-permisos-ventanas-tributacion',
            pageTitle: 'Permisos a Ventanas de Tributación',
            breadcrumb: [{
                text: 'Permisos Ventanas de Tributación',
                active: true,
            }, ],
        },
    },

    {
        path: '/sri/editar-a06t1/:Codigo',
        name: 'sri-editar-a06t1',
        component: () =>
            import ('@/views/pages/tributacion/SRI/editar-A06T1/Editar-A06T1.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-exportaciones-reporte-embarque',
            pageTitle: 'Editar Detalle',
            breadcrumb: [{
                text: 'Editar Detalle',
                active: true,
            }, ],
        },
    },

    //CONFIGURACIONES DE MÓDULO
    {
        path: '/tributacion/configuracion-impuesto-renta',
        name: 'configuracion-impuesto-renta',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/RDEP.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-parametros',
            pageTitle: 'Configuración de Tabla',
            breadcrumb: [{
                text: 'RDEP',
                active: true,
            }, ],
        },
    },
    {
        path: '/tributacion/configuracion/tipo-comprobante',
        name: 'tributacion-configuracion-tipo-comprobante',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/TipoComprobante.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-tipo-comprobante',
            pageTitle: 'Tipo Comprobante',
            breadcrumb: [{
                    text: 'Tributacion',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
                {
                    text: 'Tipo Comprobante',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/tributacion/configuracion/punto-emision',
        name: 'tributacion-configuracion-punto-emision',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/PuntoEmision.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-punto-emision',
            pageTitle: 'Punto Emision',
            breadcrumb: [{
                    text: 'Tributacion',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                },
                {
                    text: 'Punto Emision',
                    active: true,
                },
            ],
        },
    },

    //PANTALLAS PARA ATS (ANEXO TRANSACCIONAL SIMPLIFICADO)
    {
        path: '/tributacion/migrarExcel-ATS',
        name: 'tributacion-migrar-excel-ATS',
        component: () =>
            import ('@/views/pages/tributacion/ATS/ATS_MigrarExcel.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-migrar-excel-ATS',
            pageTitle: 'ATS (ANEXO TRANSACCIONAL SIMPLIFICADO)',
            breadcrumb: [{
                text: 'ATS',
                active: true,
            }, ],
        },
    },

    //PANTALLAS PARA PARAMETRIZACIONES SRI (ANEXO TRANSACCIONAL SIMPLIFICADO)
    {
        path: '/tributacion/tipo-transaccion',
        name: 'tributacion-tipo-transaccion',
        component: () =>
            import ('@/views/pages/tributacion/SRI/TiposTransaccion.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-tipo-transaccion',
            pageTitle: 'Tipo De Transacción',
            breadcrumb: [{
                text: 'Tipo De Transacción',
                active: true,
            }, ],
        },
    },

    //CONCEPTOS DE RETENCIÓN EN LA FUENTE DE IMPUESTO A LA RENTA (AIR)
    {
        path: '/tributacion/conceptos-retencion-fuente',
        name: 'tributacion-conceptos-retencion-fuente',
        component: () =>
            import ('@/views/pages/tributacion/SRI/ConceptosRetencionFuente.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-conceptos-retencion-fuente',
            pageTitle: 'Conceptos de Retención en la Fuente de Impuesto a la Renta',
            breadcrumb: [{
                text: 'Conceptos de Retención en la Fuente de Impuesto a la Renta',
                active: true,
            }, ],
        },
    },
    {
        path: '/tributacion/parametrizacion-contribuyente',
        name: 'tributacion-parametrizacion-contribuyente',
        component: () =>
            import ('@/views/pages/tributacion/SRI/ParametrizacionContribuyenteProv.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-parametrizacion-contribuyente',
            pageTitle: 'Parametrización Contribuyentes Proveedor',
            breadcrumb: [{
                text: 'Parametrización Contribuyentes Proveedor',
                active: true,
            }, ],
        },
    },
    //TIPOS DE COMPROBANTES AUTORIZADOS
    {
        path: '/tributacion/tipo-comprobantes',
        name: 'tributacion-tipo-comprobantes',
        component: () =>
            import ('@/views/pages/tributacion/SRI/TipoComprobantes.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-tipo-comprobantes',
            pageTitle: 'Tipos de Comprobantes Autorizados',
            breadcrumb: [{
                text: 'Tipos de Comprobantes Autorizados',
                active: true,
            }, ],
        },
    },

    //CÓDIGO REGIMEN
    {
        path: '/tributacion/codigo-regimen',
        name: 'tributacion-codigo-regimen',
        component: () =>
            import ('@/views/pages/tributacion/SRI/CodigoRegimen.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-codigo-regimen',
            pageTitle: 'Código de Régimen',
            breadcrumb: [{
                text: 'Código de Régimen',
                active: true,
            }, ],
        },
    },

    //ED
    {
        path: '/tributacion/configuracion/tipoFideicomiso',
        name: 'tributacion-configuracion-fideicomiso',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/TipoFideicomiso.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-fideicomiso',
            pageTitle: 'Tipo Fideicomiso',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'Tipo Fideicomiso',
                    active: true,
                }
            ],
        },
    },
    //Diego
    {
        path: '/tributacion/configuracion/tipoPaise',
        name: 'tributacion-configuracion-paises',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/Paises.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Paises',
            action: 'ver-tributacion-configuracion-paises',
            pageTitle: 'Paises',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'Paises',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/tributacion/configuracion/tipoDistritoAduanero',
        name: 'tributacion-configuracion-aduanero',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/DistritoAduanero.vue'),
        meta: {
            title: 'i18n:',
            resource: 'DistritoAduanero',
            action: 'ver-tributacion-configuracion-distrito_aduanero',
            pageTitle: 'DistritoAduanero',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'DistritoAduanero',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/tributacion/configuracion/formaPagoCobro',
        name: 'tributacion-configuracion-forma-pago',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/FormaPagoCobro.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-forma-pago',
            pageTitle: 'Forma de Pago/Cobro',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'Forma de Pago/Cobro',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/tributacion/configuracion/sustentoComprobante',
        name: 'tributacion-configuracion-sustento-comprobante',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/SustentoComprobante.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-sustento-comprobante',
            pageTitle: 'Sustento del Comprobante',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'Sustento del Comprobante',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/tributacion/configuracion/retencionIVA',
        name: 'tributacion-configuracion-retencion-iva',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/RetencionIVA.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-retencion-iva',
            pageTitle: 'Retencion de IVA',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'Retencion de IVA',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/tributacion/configuracion/tipoExportacionIngreso',
        name: 'tributacion-configuracion-tipo-exportacion-ingreso-exterior',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/TipoExportacionIngreso.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-tipo-exportacion-ingreso-exterior',
            pageTitle: 'Exportacion/Ingreso Exterior',
            breadcrumb: [{
                    text: 'Configuracion',
                },
                {
                    text: 'Exportacion/Ingreso Exterior',
                    active: true,
                }
            ],
        },
    },
    /* Jose Pacheco */
    {
        path: '/tributacion/SRI/ControldeErroresUsuariosContables',
        name: 'tributacion-SRI-Control-de-Errores-Usuarios-Contables',
        component: () =>
            import ('@/views/pages/tributacion/SRI/ControldeErroresUsuariosContables.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-SRI-Control-de-Errores-Usuarios-Contables',
            pageTitle: 'Control de errores Usuarios C.',
            breadcrumb: [{
                text: 'Control de Error Usuarios Contables',
                active: true,
            }, ],
        },
    },
    {
        path: '/tributacion/configuracion/Ciudades',
        name: 'tributacion-configuracion-ciudades',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/Ciudades.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-ciudades',
            pageTitle: 'Ciudades',
            breadcrumb: [{
                text: 'Ciudades',
                active: true,
            }, ],
        },
    },
    {
        path: '/tributacion/configuracion/CierreSRI',
        name: 'tributacion-configuracion-CierreSRI',
        component: () =>
            import ('@/views/pages/tributacion/configuracion/CierreSRI.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-configuracion-CierreSRI',
            pageTitle: 'Cierre SRI',
            breadcrumb: [{
                text: 'Cierre SRI',
                active: true,
            }, ],
        },
    },

    //Reporte de VENTAS AT

    {
        path: '/tributacion/reporte-ventasat',
        name: 'tributacion-reporte-ventasat',
        component: () =>
            import ('@/views/pages/tributacion/RDEP/VentasAT.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-reporte-ventasat',
            pageTitle: 'Reportes Ventas AT',
            breadcrumb: [{
                text: 'Reportes Ventas AT',
                active: true,
            }, ],
        },
    },

    {
        path: '/tributacion/transacciones/retenciones',
        name: 'tributacion-transacciones-retenciones',
        component: () =>
            import ('@/views/pages/tributacion/transacciones/Retenciones.vue'),
        meta: {
            title: 'i18n:',
            contentRenderer: 'sidebar-left',
            contentClass: 'chat-application',
            resource: 'Tributacion',
            action: 'ver-tributacion-transacciones-retenciones',
        },
    },
    {
        path: '/tributacion/mantenimiento/crear-provincia',
        name: 'tributacion-crear-provincia',
        component: () =>
            import ('@/views/pages/tributacion/mantenimiento/CrearProvincia.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Tributacion',
            action: 'ver-tributacion-crear-provincia',
            pageTitle: 'Crear Provincia',
            breadcrumb: [{
                text: 'Crear Provincia',
                active: true,
            }, ],
        },
    },
]
